import React from 'react';

const SearchBar = ({ searchQuery, onSearchChange, onSearch, onClear }) => {
  return (
    <form onSubmit={onSearch} className="mb-6">
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder='Search videos (e.g., "VS" for battles)...'
          className="flex-1 px-4 py-3 bg-battle-gray border border-army/50 rounded-lg text-white focus:outline-none focus:border-brand-yellow/60"
        />
        <button
          type="submit"
          className="px-6 py-3 bg-army hover:bg-army-light text-white font-semibold rounded-lg transition"
        >
          Search
        </button>
        <button
          type="button"
          onClick={onClear}
          className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-semibold rounded-lg transition"
        >
          Clear
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
